<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5 v-if="jenisPembayaran == 'PL'">Detail Pelunasan Gadai</h5>
                <h5 v-else>Detail Perpanjangan Gadai</h5>
            </template>
            <b-alert class="mt-0 mb-4" variant="primary" :show="jenisPembayaran == 'PP' && dataDetailPembayaran.statusGadai.toUpperCase() == 'PROSES LELANG'">Untuk pengecekan apabila barang gadai masih dapat dilunaskan, silahkan menuju ke menu Gadai > Pelunasan</b-alert>
    
            <DetailGadaiKomp :detailGadai="dataDetailPembayaran" />

            <div class="form-wrapper-btn" v-if="jenisPembayaran == 'PL' && dataDetailPembayaran.statusGadai.toUpperCase() == 'PROSES LELANG'">
                <b-button class="mr-2" variant="success" @click="hitungPembayaran()" :disabled="isCalculating">
                    <i class="fa fa-calculator mr-2"></i>
                    {{ isCalculating ? "Menghitung..." : "Hitung" }}
                </b-button>
                <b-button variant="pgiBtn" @click="cekStatusLelang()" :disabled="isCheckStatusLelang">
                    {{ isCheckStatusLelang ? "Memproses..." : "Cek Status Lelang" }}
                </b-button>
            </div>

            <!-- muncul klo status ajuannya acept /reject -->
            <div class="detail-data-wrapper mb-4" v-if="showStatusAjuan">
                <h6 class="form-title">STATUS AJUAN KERINGANAN</h6>
                <b-row class="mb-2">
                    <b-col cols="4"  class="detail-data-label">Status</b-col>
                    <b-col>{{ statusKeringanan }}</b-col>
                </b-row>
                <b-row class="mb-4">
                    <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                    <b-col>{{ keteranganKeringanan }}</b-col>
                </b-row>
            </div>
            <!-- ini muncul klo status gadai berjalan dan tidak ada ajuan / ato ajuan ditolak dkk -->
            <div class="detail-data-wrapper mb-4" v-if="showInputPembayaran">
                <h6 class="form-title" v-if="!isSchemeAngsuran">INPUT PEMBAYARAN</h6>
                <b-alert class="mt-2 mb-2" variant="warning" :show="cabangId != dataDetailPembayaran.cabangPenggadaian.id">
                    <strong>Perhatian!</strong>
                    <p class="mb-0">
                        Gadai ini dilakukan di cabang yang berbeda! {{dataDetailPembayaran.cabangPenggadaian.name}}
                    </p>
                </b-alert>
                <b-form>
                    <div class="form-content-wrapper mb-3" v-if="!isSchemeAngsuran">
                        <b-button v-if="showKeringananBtn" class="mb-2 mr-2" variant="pgiBtn" @click="ajukanKeringanan" name="ajukanKeringanBtn">
                            <i class="fa fa-clipboard fa-fw mr-1"></i>
                            Ajukan Keringanan Bayar
                        </b-button>
                        <b-button class="mb-2" variant="pgiBtn" name="angsuranSajaBtn" @click="ajukanAngsuranSaja">
                            <i class="fa fa-dollar fa-fw mr-1"></i>
                            Angsuran Pokok Saja
                        </b-button>
                    </div>
                    <b-form @submit.prevent v-if="!isSchemeAngsuran">
                        <b-row>
                            <b-col>
                                <b-form-group label="Voucher Diskon" label-for="voucher-input" class="mw-400">
                                <b-input-group id="voucher-input" class="w-100">
                                    <b-input-group-prepend is-text>
                                    <b-form-checkbox
                                        v-model="useVoucher"
                                        @change="onUseVoucherChange"
                                    />
                                    </b-input-group-prepend>

                                    <b-form-input
                                    v-model="voucherCode"
                                    :disabled="!useVoucher"
                                    @keyup.enter.prevent="hitungPembayaran()"
                                    ></b-form-input>
                                </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>

                    <div class="form-wrapper-btn">
                        <b-button variant="success" @click="hitungPembayaran()" :disabled="isCalculating">
                            <i class="fa fa-calculator mr-2"></i>
                            {{ isCalculating ? "Menghitung..." : "Hitung" }}
                        </b-button>
                    </div>
                </b-form>
            </div>
            <!-- ini buat klo status keringana pending doang -->
            <div class="detail-data-wrapper mb-4" v-if="showBtnCheckAjuan">
                <b-alert class="mt-4 mb-0" variant="primary" show>Ajuan keringanan sedang diproses, pembayaran dapat dilakukan setelah proses selesai.</b-alert>
                <b-btn class="mt-2 ml-0" variant="primary" @click="checkStatusKeringanan">Cek Status Ajuan Keringanan</b-btn>
                <b-btn class="mt-2 ml-2" variant="danger" @click="openModalBatal">Batalkan Ajuan Keringanan</b-btn>
            </div>

            <b-modal 
                id="modal-data-pembayaran" 
                title="Pembayaran" 
                :hide-footer="dataDetailPembayaran.statusGadai.toUpperCase() == 'PROSES LELANG'"
                @ok.prevent="executeNext"
                no-close-on-esc no-close-on-backdrop
                @close="resetBayar()"
                @cancel="resetBayar()"
            >
                <div v-if="dataHitungPembayaran.length != 0">
                    <div class="detail-data-wrapper mb-3">
                        <h6 class="form-title">RINCIAN PEMBAYARAN - <span v-if="jenisPembayaran === 'PL'">PELUNASAN</span><span v-else>PERPANJANGAN</span></h6>

                        <template v-if="isSchemeAngsuran && dataHitungPembayaran.inquiryGadaiAngsuran">
                            <b-table bordered small responsive class="rincian-angsuran-table mb-0"
                                :items="dataHitungPembayaran.inquiryGadaiAngsuran.jadwalAngsuran" :fields="jadwalAngsuranFields">
                                <template v-slot:cell(tenorKe)="row">
                                    <div class="text-center">{{ row.item.tenorKe }}</div>
                                </template>
                                <template v-slot:cell(periode)="row">
                                    {{ $helper.changeDateFormat(row.item.periode) }}
                                </template>
                                <template v-slot:cell(jasa)="row">
                                    <div class="text-right no-wrap">Rp. {{ $helper.addThousandSeparator(row.item.jasa) }}</div>
                                </template>
                                <template v-slot:cell(admin)="row">
                                    <div class="text-right no-wrap">Rp. {{ $helper.addThousandSeparator(row.item.admin) }}</div>
                                </template>
                                <template v-slot:cell(angsuran)="row">
                                    <div class="text-right no-wrap"><strong>Rp. {{ $helper.addThousandSeparator(row.item.angsuran) }}</strong></div>
                                </template>
                            </b-table>
                            <div class="rincian-angsuran-summary">
                                <div class="d-flex justify-content-between">
                                    <span>Denda</span>
                                    <span>Rp. {{ $helper.addThousandSeparator(dataHitungPembayaran.inquiryGadaiAngsuran.denda) }}</span>
                                </div>
                                <div v-if="dataHitungPembayaran.inquiryGadaiAngsuran.diskonPelunasanNominal > 0">
                                    <div class="d-flex justify-content-between">
                                        <span>Diskon Pelunasan ({{ dataHitungPembayaran.inquiryGadaiAngsuran.diskonPelunasanPersen }}%)</span>
                                        <span class="text-success">- Rp. {{ $helper.addThousandSeparator(dataHitungPembayaran.inquiryGadaiAngsuran.diskonPelunasanNominal) }}</span>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between rincian-angsuran-total">
                                    <strong>Total</strong>
                                    <strong>Rp. {{ $helper.addThousandSeparator(totalHitungPembayaran) }}</strong>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <ul class="list-pembayaran-wrapper">
                                <li v-for="(item, idx) in dataHitungPembayaran.items"  v-bind:key="idx">
                                    <p class="mb-0">{{item.name}}</p>
                                    <p v-if="item.nominal == null">{{$helper.addThousandSeparator(item.nominal)}} </p>
                                    <p v-else>Rp. {{$helper.addThousandSeparator(item.nominal)}} </p>
                                </li>
                            </ul>
                            <ul v-if="bayarBulanBerikutnya == 'true' && dataHitungPembayaran.jasaBulanBerikutnya != null" class="list-pembayaran-wrapper">
                                <li>
                                    <p class="mb-0">{{dataHitungPembayaran.jasaBulanBerikutnya.name}}</p>
                                    <p v-if="dataHitungPembayaran.jasaBulanBerikutnya.nominal == null">{{$helper.addThousandSeparator(dataHitungPembayaran.jasaBulanBerikutnya.nominal)}} </p>
                                    <p v-else>Rp. {{$helper.addThousandSeparator(dataHitungPembayaran.jasaBulanBerikutnya.nominal)}} </p>
                                </li>
                            </ul>
                            <ul v-if="bayarBulanBerikutnya == 'true' && dataHitungPembayaran.adminFeeBulanBerikutnya != null" class="list-pembayaran-wrapper">
                                <li>
                                    <p class="mb-0">{{dataHitungPembayaran.adminFeeBulanBerikutnya.name}}</p>
                                    <p v-if="dataHitungPembayaran.adminFeeBulanBerikutnya.nominal == null">{{$helper.addThousandSeparator(dataHitungPembayaran.adminFeeBulanBerikutnya.nominal)}} </p>
                                    <p v-else>Rp. {{$helper.addThousandSeparator(dataHitungPembayaran.adminFeeBulanBerikutnya.nominal)}} </p>
                                </li>
                            </ul>
                            <ul v-if="jenisPembayaran == 'PP' && dataHitungPembayaran.angsuranPokok != 0" class="list-pembayaran-wrapper">
                                <li>
                                    <p class="mb-0">Angsuran Pokok</p>
                                    <p v-if="dataHitungPembayaran.angsuranPokok == null">{{$helper.addThousandSeparator(dataHitungPembayaran.angsuranPokok)}} </p>
                                    <p v-else>Rp. {{$helper.addThousandSeparator(dataHitungPembayaran.angsuranPokok)}} </p>
                                </li>
                            </ul>
                            <div class="pl-4" v-if="bayarBulanBerikutnya == 'false'">
                                <p class="mb-0">Total : <strong>Rp. {{ $helper.addThousandSeparator(totalHitungPembayaran) }}</strong></p>
                                <p class="mb-0 smallText text-muted">Jatuh Tempo Selanjutnya : {{ $helper.changeDateFormat( dataHitungPembayaran.jatuhTempoSelanjutnya) }}</p>
                            </div>
                            <div class="pl-4" v-else>
                                <p class="mb-0">Total : <strong>Rp. {{ $helper.addThousandSeparator(totalHitungPembayaran) }}</strong></p>
                                <p class="mb-0 smallText text-muted">Jatuh Tempo Selanjutnya : {{ $helper.changeDateFormat( dataHitungPembayaran.jatuhTempo2BulanBerikutnya) }}</p>
                            </div>
                        </template>
                    </div>
                    <div class="form-content-wrapper mb-0" v-if="dataDetailPembayaran.statusGadai.toUpperCase() != 'PROSES LELANG'">
                        <h6 class="form-title">PEMBAYARAN</h6>
                        <b-row class="mb-2">
                            <b-col 
                                v-for="(label, key) in paymentMethod" 
                                :key="key" 
                                cols="4">
                                
                                <b-form-radio v-model="input.isTunai" :value="Number(key)">
                                {{ label }}
                                </b-form-radio>

                            </b-col>
                            </b-row>

                        <div>
                            <b-form-group label="Angsuran Pokok" v-if="jenisPembayaran != 'PL' && !isSchemeAngsuran"
                                description="Minimal Rp 100.000 dan kelipatan Rp 50.000. Masukkan 0 bila tidak ingin melakukan angsuran pokok.">
                                <b-input-group prepend="Rp.">
                                    <b-form-input v-model="input.angsuranPokok" :disabled="disableAngsuran" name="angsuranPokok"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-checkbox 
                                v-if="jenisPembayaran != 'PL' && dataHitungPembayaran.jasaBulanBerikutnya != null"
                                v-model="bayarBulanBerikutnya"
                                id="boolBayarBulan"
                                name="bayarBulanBerikutnya"
                                value="true"
                                unchecked-value="false"
                            >
                                Bayar bulan berikutnya
                            </b-form-checkbox>
                            <p v-if="dataHitungPembayaran.harus2BulanUntukAngsur == true" class="mb-0 smallText text-muted">Angsuran hanya dapat dilakukan bila membayar bulan berikutnya.</p>
                            <b-form-group label="Tipe Pelunasan" v-if="jenisPembayaran == 'PL'">
                                <b-form-select v-model="input.tipePelunasan">
                                    <b-form-select-option :value="null">-- Pilih Tipe --</b-form-select-option>
                                    <b-form-select-option :value="1">Nasabah + SBG</b-form-select-option>
                                    <b-form-select-option :value="2">Nasabah + Nota Hilang</b-form-select-option>
                                    <b-form-select-option :value="3">Pelunasan Diwakilkan + SBG</b-form-select-option>
                                    <b-form-select-option :value="4">Pelunasan Diwakilkan + Surat Kuasa PGI (Apabila SBG Hilang)</b-form-select-option>
                                </b-form-select>
                            </b-form-group>
                            <b-alert class="mt-2 mb-2" variant="warning" :show="input.isTunai === 4">
                            <strong>Perhatian!</strong>
                            <p class="mb-0">
                                Untuk pembayaran QR akan dikenakan biaya transaksi sebesar Rp. {{$helper.addThousandSeparator(dataHitungPembayaran.dokuFee)}}!
                            </p>
                            </b-alert>
                        </div>
                    </div>
                </div>
            </b-modal>
            <ModalKonfirmasi v-if="dataHitungPembayaran.harus2BulanUntukAngsur == true && bayarBulanBerikutnya == 'false'"
                :isSubmitting="isSubmitting" :angsuranPokok=0 :tipePembayaran="jenisPembayaran"
                :totalPembayaran="totalHitungPembayaran" :nominalPembayaran="input.nominalPembayaran" :isTunai="input.isTunai"
                :isSchemeAngsuran="isSchemeAngsuran"
                @update:nominalPembayaran="input.nominalPembayaran = $event"
                @exec-submit="submitPembayaran"
            />
            <ModalKonfirmasi v-else
                :isSubmitting="isSubmitting" :angsuranPokok="angsuranPokokNumber" :tipePembayaran="jenisPembayaran"
                :totalPembayaran="totalHitungPembayaran" :nominalPembayaran="input.nominalPembayaran" :isTunai="input.isTunai"
                :isSchemeAngsuran="isSchemeAngsuran"
                @update:nominalPembayaran="input.nominalPembayaran = $event"
                @exec-submit="submitPembayaran"
            />
            <ModalSukses :noKwitansi="noKwitansi" @done="reset" />
            <b-modal 
                id="modal-bayar-angsuranSaja" 
                title="Pembayaran Angsuran Pokok" 
                no-close-on-esc no-close-on-backdrop
            >
                <b-form id="angsuranSajaForm" @submit.prevent="bayarAngsuranSaja">
                    <div class="detail-data-wrapper mb-4">
                        <h6 class="form-title">DATA ANGSURAN</h6>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Sisa Pokok</b-col>
                            <b-col>Rp. {{$helper.addThousandSeparator(dataDetailPembayaran.pinjamanPokokEfektif) }}</b-col>
                        </b-row> 
                    </div>
                    <div class="form-content-wrapper mb-0">
                        <h6 class="form-title">PEMBAYARAN</h6>
                        <b-form-group label="Metode Pembayaran">
                            <b-row class="mb-2">
                            <b-col 
                                v-for="(label, key) in paymentMethod" 
                                :key="key" 
                                cols="4">

                                <b-form-radio v-model="input.isTunaiAngsuranSaja" :value="Number(key)">
                                {{ label }}
                                </b-form-radio>

                            </b-col>
                            </b-row>
                        </b-form-group>
        
                        <b-form-group label="Angsuran Pokok">
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="input.angsuranPokokSaja" name="angsuranPokokSaja"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </div>
                </b-form>
                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button variant="secondary" name="cancelAjukanAngsuranSajaBtn" @click="cancel()">
                        Cancel
                    </b-button>
                    <b-button variant="pgiBtn" name="bayarAngsuranSajaBtn" type="submit" form="angsuranSajaForm">
                        Kirim
                    </b-button>
                </template>
            </b-modal>
            <ModalKonfirmasiAngsuran
                :isSubmitting="isSubmitting" :angsuranPokok="angsuranPokokSajaNumber"
                :sisaPokok="dataDetailPembayaran.pinjamanPokokEfektif"
                @exec-submit="submitPembayaranAngsuran"
            />
        </b-card>

        <b-modal id="modal-keringanan-bayar" size="lg" title="Ajukan Keringanan Bayar" no-close-on-esc no-close-on-backdrop>
            <b-form id="ajukanKeringanan" @submit.prevent="openModalConfirm">
                <div class="modal-form-wrapper">
                    <b-form-group label="Nominal Pemotongan">
                        <b-input-group prepend="Rp.">
                            <b-form-input v-model="input.nominalKeringanan" name="nominalKeringanan" required></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label="Keterangan">
                        <b-form-textarea 
                        v-model="input.keteranganKeringanan"
                        name="keteranganKeringanan"
                        rows="2"
                        required
                        ></b-form-textarea>
                    </b-form-group>
                </div>
                <div class="form-content-wrapper mb-0">
                    <div>
                        <b-button variant="pgiBtn" class="mb-2" @click="addFotoPendukung" name="fotoPendukungAddBtn"><i class="fa fa-plus mr-2"></i>Foto Pendukung</b-button>
                        <div class="text-danger mt-2 mb-2" v-show="fotoPendukungError">* Foto Pendukung Maksimal 5 Foto</div>
                    
                        <FotoPendukung 
                            v-for="item in input.fotoPendukung" 
                            v-bind:key="item.index" 
                            :fotoPendukung="item" 
                            :length="input.fotoPendukung.length" 
                            :minLength="minLengthFotoPendukung"
                            :isRemove="input.fotoPendukung.length > minLengthFotoPendukung"
                            @remove="removeFotoPendukung"
                            @showModalCam="openModalCam" 
                            @showModalPreview="openModalPreview"
                        />
                    </div>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelAjukanKeringananBtn" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeAjukanKeringananBtn" type="submit" form="ajukanKeringanan">
                    Kirim
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-status-lelang" title="Status Lelang" no-close-on-backdrop no-close-on-esc hide-footer>
            <div class="text-center" v-if="isCheckStatusLelang == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
                <div v-if="statusLelangId == 1">
                    <p>Barang belum terjual dan dapat dikirimkan kembali</p>
                    <b-button variant="pgiBtn" class="mb-0" @click="requestKirimBalik()">
                        Request Kirim Balik
                    </b-button>
                </div>
                <p v-else>
                    {{statusLelangText}}
                </p>
            </div>
        </b-modal>

        <b-modal id="modal-kirim-balik" title="Request Kirim Balik" no-close-on-backdrop no-close-on-esc hide-footer>
            <div class="text-center" v-if="isReqKirimBalik == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
                <p>
                    {{kirimBalikText}}
                </p>
            </div>
        </b-modal>
        
        <ModalWebCam @photoTaken="setResult" />
        <ModalPreview :fotoPreview="activeFotoPreview" />
        <ModalConfirm id="modal-confirm-input" title="Confirm Submit Ajuan Keringanan" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengajukan keringanan ini?" @submit="submitKeringanan" />
        <ModalConfirm id="modal-confirm-batal" title="Confirm Batalkan Ajuan Keringanan" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk membatalkan ajuan keringanan ini?" @submit="batalAjuan" />

    </div>
</template>

<style>
.mw-400 {
  max-width: 400px;
}

.rincian-angsuran-table th {
  vertical-align: middle;
  font-size: 13px;
}

.rincian-angsuran-table td {
  vertical-align: middle;
  font-size: 13px;
}

.rincian-angsuran-summary {
  margin-top: 8px;
}

.rincian-angsuran-summary .rincian-angsuran-total {
  margin-top: 4px;
}

</style>

<script>

import DetailGadaiKomp from '../../components/gadai/DetailGadaiKomp'
import ModalKonfirmasi from './ModalKonfirmasi'
import ModalSukses from './ModalSukses'
import FotoPendukung from '../../components/webcam/FotoPendukung'
import ModalWebCam from '../../components/webcam/ModalWebCam'
import ModalPreview from '../../components/webcam/ModalPreview'
import ModalKonfirmasiAngsuran from './ModalKonfirmasiAngsuranSaja'

export default {
    name: 'detail-pembayaran',
    components: {
        DetailGadaiKomp,
        ModalKonfirmasi,
        ModalSukses,
        FotoPendukung,
        ModalWebCam,
        ModalPreview,
        ModalKonfirmasiAngsuran
    },
    props: {
        jenisPembayaran: { type: String, required: true },
    },
    computed: {
        isSchemeAngsuran() {
            return this.dataDetailPembayaran.gadaiScheme == 1
        },
    },
    data(){
        return {
            cabangId: '',
            noFaktur: null,
            initStatus: 0,
            isCalculating: false,
            isCheckStatusLelang: false,
            isReqKirimBalik: false,
            isSubmitting: false,
            noKwitansi: "",
            angsuranPokokNumber : 0,
            nominalPembayaranNumber :0,

            angsuranPokokSajaNumber: 0,
            showInputPembayaran: false,
            showBtnCheckAjuan: false,
            showStatusAjuan: false,


            useVoucher: false,
            voucherCode: "",

            paymentMethod : {},
            jadwalAngsuranFields: [
                { key: "tenorKe", label: "Angsuran Ke-" },
                { key: "periode", label: "Periode" },
                { key: "jasa", label: "Jasa" },
                { key: "admin", label: "Admin" },
                { key: "angsuran", label: "Angsuran" },
            ],
            input: {
                tipePembayaran: "PP",
                tglKedatangan: null,
                isTunai: 1,
                angsuranPokok: 0,

                isTunaiAngsuranSaja: 1,
                angsuranPokokSaja: 0, 
                nominalPembayaran:0,

                //keringanan
                nominalKeringanan: null,
                keteranganKeringanan: "",

                fotoPendukung: [
                    {
                        index: 0, 
                        id: 0, 
                        checkFotoBarangPendukung: false,
                        fotoBarangPendukungPlaceholder: 'Choose a file',
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: null,
                        activeFotoPendukungBase64: null,
                    }
                ],
                tipePelunasan: null
            },

            indexFotoPendukung: 0,
            fotoPendukungError: false,
            activeFotoPendukungIndex: null,
            activeFotoPreviewIndex: null,
            minLengthFotoPendukung: 1,
            activeFotoPreview: "",
            dataDetailPembayaran: [],
            dataHitungPembayaran: {
                jasaBulanBerikutnya: null,
                adminFeeBulanBerikutnya: null,
                jasaBulanBerikutnya: null,
            },
            totalHitungPembayaran: 0,
            disableAngsuran: false,
            bayarBulanBerikutnya: 'false',
            showKeringananBtn: true,
            showStatusKeringanan: false,
            statusKeringanan: null,
            keteranganKeringanan: null,
            query: "",

            statusLelangId: null,
            statusLelangText: "",
            kirimBalidId: null,
            kirimBalikText: ""
        }
    }, 
    watch: {
        "input.angsuranPokok": function(newValue) {
            if(newValue.length > 1 && newValue.charAt(0) == 0){
                newValue = parseFloat(newValue).toString()
            }
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.angsuranPokok = result);
        },
        "input.nominalPembayaran": function(newValue) {
            if(newValue.length > 1 && newValue.charAt(0) == 0){
                newValue = parseFloat(newValue).toString()
            }
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.nominalPembayaran = result);
        },
        "input.nominalKeringanan": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.nominalKeringanan = result);
        },
        "bayarBulanBerikutnya": function() {
            if (this.bayarBulanBerikutnya == 'true') {
                this.disableAngsuran = false
                this.totalHitungPembayaran = this.dataHitungPembayaran.totalBulanBerikutnya
            } 
            else {
                if (this.dataHitungPembayaran.harus2BulanUntukAngsur == true) {
                    this.disableAngsuran = true
                    this.input.angsuranPokok = 0;
                }
                 this.totalHitungPembayaran = this.dataHitungPembayaran.total
            }
        },
        "input.angsuranPokokSaja": function(newValue) {
            if(newValue.length > 1 && newValue.charAt(0) == 0){
                newValue = parseFloat(newValue).toString()
            }
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.angsuranPokokSaja = result);
        },
    },
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.noFaktur = this.$route.params.id

            let getSinglePembayaran = this.$axios.get(`gadai/detail/faktur/${this.noFaktur}`).then(response => {
                this.dataDetailPembayaran = response.data
                this.$axios.get(`gadai-keringanan-pembayaran/status/${this.dataDetailPembayaran.id}`).then(response => {
                    let dataKeringanan = response.data
                    if(this.dataDetailPembayaran.statusGadai == 'Lunas'){
                        if(dataKeringanan.status != null){
                            let nominal = this.$helper.addThousandSeparator(dataKeringanan.nominalApproved)
                            this.showStatusAjuan = true
                            this.statusKeringanan = "Ajuan keringanan diterima dengan nominal potongan Rp. " + nominal
                            this.keteranganKeringanan = dataKeringanan.keterangan
                        }
                    }
                    else if(this.dataDetailPembayaran.statusGadai == 'Berjalan'){
                        if(dataKeringanan.status == 0){ //pending
                            this.showBtnCheckAjuan = true
                        }
                        else if(dataKeringanan.status == 1){ //approved
                            this.showInputPembayaran = true 
                            this.showKeringananBtn = false
                            let nominal = this.$helper.addThousandSeparator(dataKeringanan.nominalApproved)
                            this.showStatusAjuan = true
                            this.statusKeringanan = "Ajuan keringanan diterima dengan nominal potongan Rp. " + nominal
                            this.keteranganKeringanan = dataKeringanan.keterangan
                        }
                        else if(dataKeringanan.status == 2){ //reject
                            this.showInputPembayaran = true 
                            this.showKeringananBtn = true
                            let nominal = this.$helper.addThousandSeparator(dataKeringanan.nominalRequested)
                            this.showStatusAjuan = true
                            this.statusKeringanan = "Ajuan keringanan ditolak dengan nominal potongan Rp. " + nominal
                            this.keteranganKeringanan = dataKeringanan.keterangan
                        }
                        else{
                            this.showInputPembayaran = true
                        }
                    }
                })
            })
            
            this.cabangId = this.$helper.getCabangId()

            Promise.all([getSinglePembayaran]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        reset() {
            
            this.$bvModal.hide("modal-sukses")
            this.$bvModal.hide("modal-konfirmasi")
            this.$bvModal.hide("modal-data-pembayaran")
            let path = this.$route.path.split("/")
            path.pop()
            path = path.join("/")
            this.$router.push({ path })
        },

        cekStatusLelang(){
            this.isCheckStatusLelang = true
            this.$axios.get(`lelang-kirim-balik/inquiry/${this.noFaktur}`).then(response => {
                this.$bvModal.show("modal-status-lelang")
                this.statusLelangId = response.data.id
                this.statusLelangText = response.data.name
            })
            .catch(error => {
                console.log(error)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isCheckStatusLelang = false
            })
        },

        requestKirimBalik(){
            this.isReqKirimBalik = true
            
            this.$axios.post("lelang-kirim-balik/request/?noFaktur=" + this.noFaktur).then(response => {
                this.kirimBalidId = response.data.id
                this.kirimBalikText = response.data.name
            })
            .catch(error => {
                console.log(error)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                if(this.kirimBalidId == 0){
                    this.$bvModal.show("modal-kirim-balik")
                    this.$bvModal.hide("modal-status-lelang")
                }else{
                    this.$helper.toastSucc(this, "Pengajuan kirim balik berhasil diajukan! Hubungi HO untuk keterangan lebih lanjut")
                    this.$bvModal.hide("modal-status-lelang")
                }
                this.$bvModal.hide("modal-status-lelang")
                this.isReqKirimBalik = false
            })
        },

        hitungPembayaran() {
        if (this.useVoucher && this.$helper.isNullOrEmpty(this.voucherCode)) {
            this.$helper.toastErr(this, "Kode voucher harus diinput terlebih dahulu.")
            return;    
        }
        
        this.isCalculating = true

        let url = "gadai-pembayaran/inquiry/?jenis=" + this.jenisPembayaran
                + "&noFaktur=" + this.noFaktur
                + "&cabangPembayaranId=" + this.cabangId

        if (this.useVoucher) {
            url += "&voucherCode=" + this.voucherCode
        }

        this.$axios.get(url).then(response => {
            this.$bvModal.show("modal-data-pembayaran")
            this.dataHitungPembayaran = response.data

            this.paymentMethod = response.data.paymentMethod
            
            if (this.dataHitungPembayaran.jasaBulanBerikutnya == null) {
                this.bayarBulanBerikutnya = 'false'
            }

            this.totalHitungPembayaran = this.dataHitungPembayaran.total

            if (
                this.dataHitungPembayaran.jasaBulanBerikutnya != null &&
                this.dataHitungPembayaran.harus2BulanUntukAngsur === true
            ) {
                this.disableAngsuran = true
            }
        })
        .catch(error => {
            console.log(error)
            this.$helper.parseError(this, error)
        })
        .finally(() => {
            this.isCalculating = false
        })
        },

        executeNext() {
            this.input.nominalPembayaran = '0'

            const numberAngsuran = this.$helper.removeThousandSeparator(this.input.angsuranPokok)
            const nominalPembayaran = this.$helper.removeThousandSeparator(this.input.nominalPembayaran)

            if (numberAngsuran == 0 || numberAngsuran == null || this.dataHitungPembayaran.harus2BulanUntukAngsur == true && this.bayarBulanBerikutnya == 'false'){
                if(this.jenisPembayaran == 'PL' &&  this.input.tipePelunasan == null){
                    return this.$helper.toastErr(this, "Mohon Pilih Tipe Pelunasan")
            }   else{
                this.$bvModal.show("modal-konfirmasi")
                this.angsuranPokokNumber = JSON.parse(JSON.stringify(this.input.angsuranPokok))
                this.nominalPembayaranNumber = nominalPembayaran
                this.angsuranPokokNumber = 0
                }

            } 

            else if (numberAngsuran < 100000){
                this.$helper.toastErr(this, "Angsuran Pokok minimal Rp 100.000")
            }
            else if (numberAngsuran % 50000 != 0) {
                this.$helper.toastErr(this, "Angsuran Pokok hanya boleh dalam kelipatan Rp 50.000!")
            }
            else {
                this.$bvModal.show("modal-konfirmasi");
                
                if (this.input.angsuranPokok != 0 && this.jenisPembayaran == "PP") {
                    this.angsuranPokokNumber = JSON.parse(JSON.stringify(this.input.angsuranPokok))
                    this.angsuranPokokNumber = numberAngsuran;
                    this.nominalPembayaranNumber = nominalPembayaran
                }
            }
        },

        bayarAngsuranSaja(){
            const numberAngsuran = this.$helper.removeThousandSeparator(this.input.angsuranPokokSaja)

            if (numberAngsuran < 100000){
                this.$helper.toastErr(this, "Angsuran Pokok minimal Rp 100.000")
            }
            else if (numberAngsuran % 50000 != 0) {
                this.$helper.toastErr(this, "Angsuran Pokok hanya boleh dalam kelipatan Rp 50.000!")
            }else if(numberAngsuran > this.dataDetailPembayaran.pinjamanPokokEfektif){
                this.$helper.toastErr(this, "Angsuran Pokok lebih besar dari sisa pokok!")
            }
            else {
                this.$bvModal.show("modal-konfirmasi-angsuranSaja");
                this.angsuranPokokSajaNumber = JSON.parse(JSON.stringify(this.input.angsuranPokokSaja))
                this.angsuranPokokSajaNumber = numberAngsuran;
            }
        },

        //----------------- Fungsi Submit Data -----------------

        submitPembayaran() {
            const numberAngsuran = this.$helper.removeThousandSeparator(this.input.angsuranPokok)
            const nominalPembayaran = this.$helper.removeThousandSeparator(this.input.nominalPembayaran)
            const total = this.$helper.removeThousandSeparator(this.totalHitungPembayaran)

            if (this.input.isTunai == 1 && numberAngsuran+total > nominalPembayaran){
                if(this.jenisPembayaran == "PP"){
                this.$helper.toastErr(this, "Nominal Pembayaran harus lebih besar dari total (dan angsuran, bila ada)")
                }else{
                this.$helper.toastErr(this, "Nominal Pembayaran harus lebih besar dari total")
                }
            }else{
            let payload = new FormData()

            //----------------- Append Data Payload -----------------
            
            payload.append("jenis", this.jenisPembayaran)
            payload.append("noFaktur", this.noFaktur)
            payload.append("methodPayment", this.input.isTunai)
            // payload.append("isTunai", this.input.isTunai == 1)
            if(this.input.isTunai == 1){
                payload.append("nominalBayar", this.$helper.removeThousandSeparator(this.input.nominalPembayaran))
            }
            if (this.jenisPembayaran == 'PL') {   
                payload.append("tipePelunasan", this.input.tipePelunasan)
            }
            payload.append("cabangPembayaranId", this.cabangId )
            if (this.angsuranPokokNumber != 0) {
                payload.append("angsuranPokok", this.angsuranPokokNumber)
            }

            if (this.bayarBulanBerikutnya == 'true') payload.append("bayarBulanBerikutnya", true)

            if (this.useVoucher == true) {
                payload.append("voucherCode", this.voucherCode)
            }
            
            //----------------- Submit Semua Data -----------------
            
            this.isSubmitting = true
             
            this.$axios.post("gadai-pembayaran/bayar/", payload).then(response => {
                
                // Lakukan hit tambahan bila menggunakan QRIS
                if(this.input.isTunai == 3) {
                    this.$axios.get("gadai-pembayaran/generate-qris/" + response.data.id).then(res2 => {
                        this.noKwitansi = res2.data.name
                        this.$bvModal.show("modal-sukses")
                    })
                    .catch(error => {
                        this.$helper.parseError(this, error)
                    })
                    .finally(() => this.isSubmitting = false)
                }
                else {
                    this.noKwitansi = response.data.name
                    this.$bvModal.show("modal-sukses")
                    this.isSubmitting = false
                }

            })
            .catch(error => {
                console.log(error)
                this.$helper.parseError(this, error)
                this.isSubmitting = false
            })
            }
        },

        submitPembayaranAngsuran(){
            let payload = new FormData()

            //----------------- Append Data Payload -----------------

            payload.append("noFaktur", this.noFaktur)
            payload.append("methodPayment", this.input.isTunaiAngsuranSaja)
            payload.append("cabangPembayaranId", this.cabangId )
            if (this.angsuranPokokSajaNumber != 0) {
                payload.append("angsuranPokok", this.angsuranPokokSajaNumber)
            }
            
            //----------------- Submit Semua Data -----------------
            this.$helper.printPayload(payload)
            this.isSubmitting = true
            
            this.$axios.post("gadai-pembayaran/angsuran/", payload).then(response => {
                // Lakukan hit tambahan bila menggunakan QRIS
                if(this.input.isTunaiAngsuranSaja == 3) {
                    this.$axios.get("gadai-pembayaran/generate-qris/" + response.data.id).then(res2 => {
                        this.noKwitansi = res2.data.name
                        this.$bvModal.show("modal-sukses")
                    })
                    .catch(error => {
                        this.$helper.parseError(this, error)
                    })
                    .finally(() => this.isSubmitting = false)
                }
                else {
                    this.noKwitansi = response.data.name
                    this.$bvModal.show("modal-sukses")
                    this.isSubmitting = false
                }
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.isSubmitting = false
            })
        },

        submitKeringanan(){

            let payload = new FormData()
            let nominalKeringanan = this.$helper.removeThousandSeparator(this.input.nominalKeringanan)

            //----------------- Append Data Payload -----------------
            
            payload.append("gadaiId", this.dataDetailPembayaran.id)
            payload.append("nominal", nominalKeringanan)
            payload.append("keterangan", this.input.keteranganKeringanan)
            payload.append("jenis", this.jenisPembayaran)

            let jsonFoto = []
            for(let x = 0; x< this.input.fotoPendukung.length ;x++){
                let item = this.input.fotoPendukung[x]
                if(this.$helper.isNullOrEmpty(item.activeFotoPendukungBase64)) {
                    this.$helper.toastErr(this, "Terdapat upload gambar yang kosong, periksa kembali!")
                    return
                }else{
                    jsonFoto.push(item.activeFotoPendukungBase64)
                }
            }

            payload.append("fotoBukti", JSON.stringify(jsonFoto))
            
            //----------------- Submit Semua Data -----------------
            
            this.isSubmitting = true

            this.$axios.post("gadai-keringanan-pembayaran/request", payload, { timeout: 300000 }).then(() => {
                this.$bvModal.hide("modal-confirm-input")
                this.$bvModal.hide("modal-keringanan-bayar")
                this.showInputPembayaran = false
                this.showBtnCheckAjuan = true
                this.$helper.setFlash("Pengajuan keringanan berhasil dilakukan!")
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        ajukanAngsuranSaja(){
            this.query = "?jenis=PL&noFaktur="+this.noFaktur+"&cabangPembayaranId="+ this.cabangId

            //----------------- Submit Semua Data -----------------
            
            this.isSubmitting = true
            this.$axios.get("gadai-pembayaran/inquiry"+this.query).then(response => {
                if(response.data.items.length != 1){
                    this.$helper.toastErr(this, "Tidak dapat melakukan angsuran saja - terdapat biaya jasa yang belum terbayar!")
                }else{
                    this.paymentMethod = response.data.paymentMethod
                    this.$bvModal.show("modal-bayar-angsuranSaja")
                }
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        //----------------- Fungsi Lain -----------------

        checkStatusKeringanan(){
            this.$axios.get(`gadai-keringanan-pembayaran/status/${this.dataDetailPembayaran.id}`).then(response => {
                let dataKeringanan = response.data

                if (dataKeringanan.status == 1) {
                    this.showBtnCheckAjuan = false
                    this.showStatusAjuan = true
                    this.showInputPembayaran = true
                    this.showStatusKeringanan = true
                    this.showKeringananBtn = false
                    
                    let nominal = this.$helper.addThousandSeparator(dataKeringanan.nominalApproved)

                    this.statusKeringanan = "Ajuan keringanan diterima dengan nominal potongan Rp. " + nominal
                    if (dataKeringanan.keterangan != null) this.keteranganKeringanan = dataKeringanan.keterangan
                    else this.keteranganKeringanan = "-"
                }
                else if (dataKeringanan.status == 2) {
                    this.showBtnCheckAjuan = false
                    this.showStatusAjuan = true
                    this.showInputPembayaran = true
                    this.showStatusKeringanan = true
                    this.input.nominalKeringanan = 0
                    
                    let nominal = this.$helper.addThousandSeparator(dataKeringanan.nominalRequested)

                    this.statusKeringanan = "Ajuan keringanan ditolak dengan nominal potongan Rp. " + nominal
                    if (dataKeringanan.keterangan != null) this.keteranganKeringanan = dataKeringanan.keterangan
                    else this.keteranganKeringanan = "-"
                }
                else {
                    this.$helper.toastAlert(this, "Ajuan keringanan masih diproses.")
                }
            })
        },

        batalAjuan(){
            let payload = new FormData
            payload.append('gadaiId', this.dataDetailPembayaran.id)

            this.$axios.post(`gadai-keringanan-pembayaran/cancel`, payload).then(response => {
                let dataKeringanan = response.data
                this.showBtnCheckAjuan = false
                this.showInputPembayaran = true
                this.showStatusAjuan = true
                this.showStatusKeringanan = true
                this.input.nominalKeringanan = 0
                
                let nominal = this.$helper.addThousandSeparator(dataKeringanan.nominalRequested)

                this.statusKeringanan = "Ajuan keringanan dibatalkan dengan nominal potongan Rp. " + nominal
                if (dataKeringanan.keterangan != null) this.keteranganKeringanan = dataKeringanan.keterangan
                else this.keteranganKeringanan = "-"

                this.$bvModal.hide("modal-confirm-batal")
            })
        },

        openModalConfirm(){
            if (this.input.fotoPendukung.length == 0) this.$helper.toastErr(this, "Mohon masukkan minimal satu foto pendukung")
            else if (this.input.fotoPendukung.length == 1 && this.input.fotoPendukung[0].checkFotoBarangPendukung == false) this.$helper.toastErr(this, "Mohon masukkan minimal satu foto pendukung")
            else this.$bvModal.show("modal-confirm-input")
        },

        openModalBatal(){
            this.$bvModal.show("modal-confirm-batal")
        },

        ajukanKeringanan(){
            this.$bvModal.show("modal-keringanan-bayar")
        },

        resetBayar(){
            this.bayarBulanBerikutnya = 'false'
        },

        openModalCam(index){
            this.activeFotoPendukungIndex = index
            this.$bvModal.show("modal-ambil-foto")
        },
        
        openModalPreview(index){
            this.activeFotoPreviewIndex = index
            let idx = this.input.fotoPendukung.findIndex(item => item.index == this.activeFotoPreviewIndex);
            this.activeFotoPreview = this.input.fotoPendukung[idx].fotoBarangPendukungBase64
            this.$bvModal.show("modal-preview-foto")
        },

        async setResult(result){
            //letakin ke null masing2
            var newResult = await this.$helper.resizeImage(result)
            let idx = this.input.fotoPendukung.findIndex(item => item.index == this.activeFotoPendukungIndex);
            this.input.fotoPendukung[idx].fotoBarangPendukungBase64 = newResult
            this.input.fotoPendukung[idx].activeFotoPendukungBase64 = newResult
            this.input.fotoPendukung[idx].fotoBarangPendukungPlaceholder = "Foto dari Kamera"
            this.input.fotoPendukung[idx].checkFotoBarangPendukung = true
        },

        //----------------- Fungsi Tambah Hapus Data Foto Pendukung -----------------

        addFotoPendukung() {
            if(this.input.fotoPendukung.length < 5){
                this.input.fotoPendukung.unshift({ 
                    index: this.indexFotoPendukung + 1, 
                    id: 0, 
                    checkFotoBarangPendukung: false,
                    fotoBarangPendukungPlaceholder: 'Choose a file',
                    fotoBarangPendukung: null,
                    fotoBarangPendukungBase64: null,
                    activeFotoPendukungBase64: null
                })
                this.indexFotoPendukung++;
            }else{
                this.fotoPendukungError = true;
            }
        },

        removeFotoPendukung(index) {
            this.input.fotoPendukung = this.input.fotoPendukung.filter(item => item.index != index)
            this.fotoPendukungError = false;
        },
          onUseVoucherChange(val) {
            if (!val) {
            this.voucherCode = '';
            }
          },
    },

    created(){
        /**
         * Initialize the component
         */
        this.init()
    }
}
</script>



